import { useParams } from 'react-router';
import { Header } from '@/components/layout/Header';
import { PageBody } from '@/components/layout/PageBody';
import { WorkflowExecution } from '@/components/workflows/WorkflowExecution';

export function WorkflowExecutionPage(): React.ReactElement {
  const { runId } = useParams<{ runId: string }>();

  if (!runId) {
    return (
      <div className="flex items-center justify-center h-full text-text-secondary">
        <p>No workflow run ID specified.</p>
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <Header title="Workflow Run" />
      <PageBody
        maxWidthClassName="max-w-[1600px]"
        className="overflow-hidden"
        contentClassName="h-full"
      >
        <div className="h-full overflow-hidden rounded-2xl border border-border/70 bg-surface/95 shadow-sm backdrop-blur-sm">
          <WorkflowExecution key={runId} runId={runId} />
        </div>
      </PageBody>
    </div>
  );
}
